import { Box, Dialog, DialogContent, DialogContentText, Grid2, IconButton, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material"
import './addclient.css'
import MUIButton from "../../reusable_components/components/MUIButton"
import MUICancelButton from "../../reusable_components/components/MuiCancelButton"
import { useContext, useEffect, useState } from "react"
import * as Yup from 'yup'
import { yupResolver } from "@hookform/resolvers/yup"
import { Controller, useForm } from "react-hook-form"
import { useDeleteTableDatasMutation, useGetClientContactByIdMutation, useSaveClientContactMutation, useSaveClientMutation, useViewClientByIdMutation } from "../../redux/clients/clients.api"
import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DeleteIcon from "../../assets/Icons/DeleteIcon"
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Dropdown from "../../reusable_components/components/Dropdown"
import DoneIcon from '@mui/icons-material/Done';
import MuiDatePicker from '../../reusable_components/components/MuiDatePicker';
import dayjs from "dayjs"
import Loader from "../../reusable_components/components/Loader";
import ClearIcon from '@mui/icons-material/Clear';
import { useGetEmailDropdownQuery } from "../../redux/candidateprofiles/candidateprofiles.api"

const AddClient = () => {
    // For Client Details
    const { Profile } = useSelector((state) => state.common)

    const userRole = Profile?.profile?.role
    const useremail = Profile?.profile?.emailId
    const isExternal = Profile?.profile?.isExternalRecruiter

    const [isCost, setIsCost] = useState(false)
    const [isContractCost, setIsContractCost] = useState(false)
    const [status, setStatus] = useState(false)
    const params = useParams()
    const editScreen = +params?.id

    const maxLength = 45;
    const [displayNameLength, setDisplayNameLength] = useState(0);
    const [clientNameLength, setClientNameLength] = useState(0);
    const [showOverAllLoader, setShowOverAllLoader] = useState(false);
    const [openStatus, setOpenStatus] = useState(false);
    const [clientStatusId, setClientStatusId] = useState("")

    const useLocations = useLocation()
    const { isReferrals, isReferralClient, clientById, clientId, clientTitle } = useLocations?.state || false

    const validationSchema = Yup.object().shape({
        clientName: userRole !== 'recruiter' || isExternal === "N" ?
            Yup.string().required('Client Name is Required').matches(/^[a-zA-Z0-9\s]+$/, 'Client Name should contain only letters and numbers') :
            Yup.string().nullable().notRequired().test(
                'Client Name should contain only letters and numbers',
                'Client Name should contain only letters and numbers',
                (value) => {
                    if (!value) return true;
                    return /^[a-zA-Z0-9\s]+$/.test(value);
                }
            ),
        clientPhone: userRole !== 'recruiter' || isExternal === "N" ? Yup.string().required("Contact Number is Required").matches(/^\+?[0-9]+$/, "Only numbers are allowed")
            : Yup.string().nullable().notRequired(),
        city: Yup.string().required('City is Required')
            .matches(/^[a-zA-Z\s]+$/, 'City Should contain only letters'),
        // pincode: editScreen ? Yup.string().required('Pincode is Required').min(6, "Pincode should be 6 digits").max(6, "Pincode should be exactly 6 digits")
        //     .matches(/^[a-zA-Z0-9]+$/, 'Pincode should be Alphanumeric only')
        //     : Yup.string(),
        pincode: editScreen ? Yup.string().test(
            'Pincode should be exactly 6 digits',
            'Pincode should be exactly 6 digits',
            (value) => {
                if (!value) return true;
                return /^[0-9]{6}$/.test(value)
            }
        ) :
            Yup.string().test(
                'Pincode should be exactly 6 digits',
                'Pincode should be exactly 6 digits',
                (value) => {
                    if (!value) return true;
                    return /^[0-9]{6}$/.test(value)
                }
            ),
        clientEmail: userRole !== 'recruiter' || isExternal === "N" ?
            Yup.string()
                .nullable().required("Email is required")
                .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                    if (!value) return true;
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(value);
                })
            : Yup.string().notRequired().nullable().test(
                'Enter Valid Email', 'Enter Valid Email', (value) => {
                    if (!value) return true;
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(value);
                }
            ),
        address: userRole !== 'recruiter' || isExternal === "N" ? Yup.string().required("Address is required")
            : Yup.string(),
        state: userRole !== 'recruiter' || isExternal === "N" ? Yup.string().required("State is required")
            : Yup.string().nullable().notRequired().test(
                'State should contain only letters',
                'State should contain only letters',
                (value) => {
                    if (!value) return true;
                    return /^[a-zA-Z\s]+$/.test(value);
                }
            ),
        country: userRole !== 'recruiter' || isExternal === "N" ? Yup.string().required("Country is required")
            : Yup.string().nullable().notRequired().test(
                'Country should contain only letters',
                'Country should contain only letters',
                (value) => {
                    if (!value) return true;
                    return /^[a-zA-Z\s]+$/.test(value);
                }
            ),
        rewardType: editScreen && isReferralClient === "Y" && userRole === "admin" ?
            Yup.string().required("Commission type is required") :
            Yup.string(),
        rewardsRs: isCost && editScreen && isReferralClient === "Y" && userRole === "admin" ?
            Yup.string().required('Commission amount is required').matches(/^[1-9][0-9]*$/, "Commission amount should be greater than 0.") :
            Yup.string(),
        rewardsPercent:
            isCost === false &&
                editScreen &&
                isReferralClient === "Y" &&
                userRole === "admin"
                ? Yup.number()
                    .typeError("Commission percentage is required")
                    .required("Commission percentage is required")
                    .min(1, "Commission percentage should be greater than 0")
                    .max(100, "Commission percentage cannot exceed 100")
                : Yup.mixed()
                    .transform((value, originalValue) =>
                        originalValue === "" ? undefined : Number(originalValue)
                    )
                    .test(
                        "is-valid-reward-percent",
                        "Commission percentage must be between 1 and 100",
                        (value) => {
                            if (value === undefined || value === null) return true; // skip if empty
                            return !isNaN(value) && value >= 1 && value <= 100;
                        }
                    ),
        agreementStartDate: userRole !== 'recruiter' || isExternal === "N" ? Yup.date().required("Agreement Start date is required")
            : Yup.date().nullable(),
        agreementEndDate: userRole !== 'recruiter' || isExternal === "N" ? Yup.date().required("Agreement End date is required")
            : Yup.date().nullable(),
        displayName: userRole !== 'recruiter' || isExternal === "N" ?
            Yup.string().test(
                'Display Name validation',
                'Display Name must be contain only letters',
                value => {
                    if (!value) return true;
                    return /^[A-Za-z\s]+$/.test(value) && value.length <= 45;
                }
            ).required("Display name is required") : Yup.string().test(
                'Display Name validation',
                'Display Name must be contain only letters',
                value => {
                    if (!value) return true;
                    return /^[A-Za-z\s]+$/.test(value) && value.length <= 45;
                }
            ),
        alternateEmail: editScreen ? Yup.string()
            .nullable()
            .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                if (!value) return true;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(value);
            })
            .test('not-same', 'Alternate Email should not be the same as client primary email', function (value) {
                const { clientEmail } = this.parent;
                return !value || value !== clientEmail;
            }) : Yup.string().nullable()
                .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                    if (!value) return true;
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emailRegex.test(value);
                })
                .test('not-same', 'Alternate Email should not be the same as client primary email', function (value) {
                    const { clientEmail } = this.parent;
                    return !value || value !== clientEmail;
                }),
        alternateNumber: editScreen ? Yup.string()
            .nullable()
            .test('not-same', 'Alternate Number should not be the same as client primary number', function (value) {
                const { clientPhone } = this.parent;
                return !value || value !== clientPhone;
            }) : Yup.string()
                .nullable()
                .test('not-same', 'Alternate Number should not be the same as client primary number', function (value) {
                    const { clientPhone } = this.parent;
                    return !value || value !== clientPhone;
                }),
        submittedBy: userRole !== 'recruiter' || isExternal === "N" ? Yup.string().required("Sourced by email is required")
            : Yup.string().nullable().notRequired(),
        contractRewardType: editScreen && isReferralClient === "Y" && userRole === "admin" ?
            Yup.string().required("Contract commission type is required") :
            Yup.string(),
        contractRewardRs: isContractCost && editScreen && isReferralClient === "Y" && userRole === "admin" ?
            Yup.string().required('Contract commission amount is required').matches(/^[1-9][0-9]*$/, "Contract commission amount should be greater than 0.") :
            Yup.string(),
        contractRewardPercent:
            isContractCost === false &&
                editScreen &&
                isReferralClient === "Y" &&
                userRole === "admin"
                ? Yup.number()
                    .typeError("Contract commission percentage is required")
                    .required("Contract commission percentage is required")
                    .min(1, "Value must be greater than 0")
                    .max(100, "Percentage cannot exceed 100")
                : Yup.mixed()
                    .transform((value, originalValue) => {
                        return originalValue === "" ? undefined : Number(originalValue);
                    })
                    .test(
                        "is-valid-contract-percentage",
                        "Value must be between 1 and 100",
                        (value) => {
                            if (value === undefined || value === null) return true;
                            return !isNaN(value) && value >= 1 && value <= 100;
                        }
                    ),

    })

    const resolver = yupResolver(validationSchema)

    const {
        control,
        register,
        handleSubmit,
        reset,
        watch,
        trigger,
        setValue,
        formState: { errors }
    } = useForm({
        resolver,
        mode: 'onChange',
        defaultValues: {
            clientName: "",
            clientPhone: "",
            city: "",
            pincode: "",
            address: "",
            state: "",
            agreementStartDate: null,
            agreementEndDate: null,
            displayName: "",
            // Default values for add client contacts
            contactName: "",
            contactNumber: "",
            email: "",
            feedBack: '',
            rewardType: "",
            rewardsRs: "",
            rewardsPercent: "",
            alternateEmail: "",
            alternateNumber: "",
            submittedBy: "",
            contractRewardType: "",
            contractRewardRs: "",
            contractRewardPercent: "",

        }
    })

    // For Add Client contacts
    const validationSchemaAddContact = Yup.object().shape({
        contactName: Yup.string().required("Client Name is Required")
            .matches(/^[A-Za-z\s]+$/, 'Client Name should contain only letters'),
        contactNumber: Yup.string().required("Contact Number is Required").matches(/^\+?[0-9]+$/, "Only numbers are allowed"),
        email: Yup.string().required('Email Id is Required')
            .test('Enter Valid Email', 'Enter Valid Email', (value) => {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return emailRegex.test(value);
            })
    })

    const resolverAddContact = yupResolver(validationSchemaAddContact)

    const {
        control: controlAddContact,
        handleSubmit: handleSubmitAddContact,
        formState: { errors: errorsAddContact },
        reset: resetAddContact,
    } = useForm({
        resolver: resolverAddContact,
        mode: 'onChange',
        defaultValues: {
            contactName: "",
            contactNumber: "",
            email: ""
        }
    })

    const navigate = useNavigate()
    const { Snackbar } = useContext(SnackbarContext)
    const theme = useTheme()
    const isSmallcreen = useMediaQuery(theme.breakpoints.down('md'))

    const [streetBuilding, setStreetBuilding] = useState("")
    const [state, setState] = useState("")
    const [country, setCountry] = useState("")
    const [email, setEmail] = useState("")
    const [WebsiteName, setWebsiteName] = useState("")
    const [alternateNumber, setAlternateNumber] = useState("")
    const [alternateEmail, setAlternateEmail] = useState("")
    const [clientContactTableDatas, setClientContactTableDatas] = useState([])
    const [clientContactRowIndex, setClientContactRowIndex] = useState("")
    const [submitRows, setSubmitRows] = useState([]);
    const [reasonForReject, setReasonForReject] = useState("")
    const [reasonError, setReasonError] = useState("");
    const [agreementStartDate, setAgreementStartDate] = useState(null)
    const [agreementEndDate, setAgreementEndDate] = useState(null)


    // Add Client contacts
    const [designation, setDesignation] = useState("")
    const [location, setLocation] = useState("")
    const [addClientAlternateNo, setAddClientAlternateNo] = useState("")
    const [addClientAlternateEmail, setAddClientAlternateEmail] = useState("")
    const [open, setOpen] = useState(false)

    const handleOpen = (item, index) => {
        setOpen(true)
        setClientContactRowIndex(index)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const [saveClient] = useSaveClientMutation()
    const [viewClient, { data: getClientDetails }] = useViewClientByIdMutation()
    const [getClientContactById] = useGetClientContactByIdMutation()
    const [saveClientContact] = useSaveClientContactMutation()
    const [deleteTableDatas] = useDeleteTableDatasMutation()
    const { data: getDropdownDatas } = useGetEmailDropdownQuery();


    useEffect(() => {
        try {
            if (editScreen) {
                const payload = {
                    clientId: editScreen
                }
                viewClient(payload);
            }

            if (editScreen) {
                getClientDatas()
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }, [editScreen, viewClient]);

    const getClientDatas = async () => {
        try {
            const payload = {
                clientId: editScreen
            }

            const response = await getClientContactById(payload).unwrap()
            setClientContactTableDatas(response?.response)

        } catch (err) {
            Snackbar("Network Error", 'error')
        }
    }

    useEffect(() => {
        if (editScreen) {
            setStatus(true)
        }
    }, [editScreen])

    const [clientCreatedById, setClientCreatedById] = useState()
    const [clientSubmittedById, setClientSubmittedById] = useState()

    useEffect(() => {
        if (getClientDetails) {
            const defaultValues = {
                // These 4 datas are yup not handled using useState
                clientName: getClientDetails?.response?.data[0]?.clientName,
                clientPhone: getClientDetails?.response?.data[0]?.clientPhone,
                city: getClientDetails?.response?.data[0]?.city,
                pincode: getClientDetails?.response?.data[0]?.pincode,
                agreementStartDate: getClientDetails?.response?.data[0]?.agreementStartDate,
                agreementEndDate: getClientDetails?.response?.data[0]?.agreementEndDate,

                address: getClientDetails?.response?.data[0]?.clientAddress,
                state: getClientDetails?.response?.data[0]?.state,
                country: getClientDetails?.response?.data[0]?.country,
                clientEmail: getClientDetails?.response?.data[0]?.clientEmail,
                displayName: getClientDetails?.response?.data[0]?.displayName,
                websiteName: getClientDetails?.response?.data[0]?.websiteName,
                alternateNumber: getClientDetails?.response?.data[0]?.alternateNumber,
                alternateEmail: getClientDetails?.response?.data[0]?.alternateEmail,
                submittedBy: getClientDetails?.response?.data[0]?.submittedBy,

                clientId: getClientDetails?.response?.data[0]?.clientId,
                clientStatusId: getClientDetails?.response?.data[0]?.clientStatusId,
                clientStatusName: getClientDetails?.response?.data[0]?.clientStatusName,
                feedBack: getClientDetails?.response?.data[0]?.feedBack,
                rewardsRs: getClientDetails?.response?.data[0]?.clientRewardAmount ?? undefined,

                rewardType: getClientDetails?.response?.data[0]?.clientRewardType === null
                    ? ''
                    : getClientDetails?.response?.data[0]?.clientRewardType === 'FC'
                        ? 1
                        : 2,
                rewardsPercent: getClientDetails?.response?.data[0]?.clientRewardPct === null ? "" : getClientDetails?.response?.data[0]?.clientRewardPct,
                contractRewardRs: getClientDetails?.response?.data[0]?.contractRewardAmount ?? undefined,

                contractRewardType: getClientDetails?.response?.data[0]?.contractRewardType === null
                    ? ''
                    : getClientDetails?.response?.data[0]?.contractRewardType === 'FC'
                        ? 1
                        : 2,
                contractRewardPercent: getClientDetails?.response?.data[0]?.contractRewardPct === null ? "" : getClientDetails?.response?.data[0]?.contractRewardPct,
            }
            reset({
                ...defaultValues,
            });

            setClientNameLength(defaultValues.clientName?.length || 0);
            setDisplayNameLength(defaultValues.displayName?.length || 0);

            setClientCreatedById(getClientDetails?.response?.data[0]?.clientCreatedById)
            setClientSubmittedById(getClientDetails?.response?.data[0]?.clientSubmittedById)

            setAlternateEmail(defaultValues?.alternateEmail)
            setState(defaultValues?.state)
            setCountry(defaultValues?.country)
            setEmail(defaultValues?.clientEmail)
            setWebsiteName(defaultValues?.websiteName)
            setAlternateNumber(defaultValues?.alternateNumber)
            setClientStatusId(defaultValues?.clientStatusId)
            setReasonForReject(defaultValues?.feedBack)
        }
    }, [getClientDetails, reset])


    const hanldeReasonForReject = (e) => {
        const value = e.target.value
        setReasonForReject(value);
        setReasonError("");
    }

    const hanldeStreetBuildingChange = (e) => {
        const value = e.target.value
        setStreetBuilding(value)
    }

    const handleStateChange = (e) => {
        const value = e.target.value
        setState(value)
    }

    const handleCountryChange = (e) => {
        const value = e.target.value
        setCountry(value)
    }

    const handleEmailChange = (e) => {
        const value = e.target.value
        setEmail(value)
    }

    // const handleDisplayNameChange = (e) => {
    //     const value = e.target.value
    //     setDisplayName(value)
    // }

    const handleWebsiteNameChange = (e) => {
        const value = e.target.value
        setWebsiteName(value)
    }

    const handleAlternateNoChange = (e) => {
        const value = e.target.value
        setAlternateNumber(value)
    }

    const handleAlternateEmailChange = (e) => {
        const value = e.target.value
        setAlternateEmail(value)
    }

    const handleStatusChange = (e) => {
        const value = e.target.value
        setClientStatusId(value)
    }

    const handleAgreementStartDate = (value) => {
        setAgreementStartDate(value)
    }

    const handleAgreementEndDate = (value) => {
        setAgreementEndDate(value)
    }

    // Add Client Contact
    const handleDesignationChange = (e) => {
        const value = e.target.value
        setDesignation(value)
    }

    const handleLocationChange = (e) => {
        const value = e.target.value
        setLocation(value)
    }

    const handleAddClientAlternateNoChange = (e) => {
        const value = e.target.value
        setAddClientAlternateNo(value)
    }

    const handleAddClientAlternateEmailChange = (e) => {
        const value = e.target.value
        setAddClientAlternateEmail(value)
    }

    const handleToggleUpdate = (index) => {
        setSubmitRows((prev) =>
            prev.includes(index)
                ? prev.filter((rowIndex) => rowIndex !== index)
                : [...prev, index]
        );
    };

    const submittedBy = watch("submittedBy")

    const onSubmit = async (data) => {
        try {
            const createdBy = Profile?.profile?.emailId
            if (clientStatusId === 2 && !reasonForReject) {
                setReasonError("Reason for Rejection is required.");
                return; // Prevent further execution
            }
            // For Add Screen
            if (!editScreen) {
                const payload = {
                    clientId: "",
                    updatedBy: "",
                    alternateEmail: data?.alternateEmail || "",
                    alternateNumber: data?.alternateNumber || "",
                    city: data?.city || "",
                    clientAddress: data?.address || "",
                    clientEmail: email || "",
                    clientName: data?.clientName || "",
                    clientPhone: !data?.clientPhone ? "" : data?.clientPhone,
                    country: data?.country || "",
                    createdBy: createdBy || "",
                    displayName: data?.displayName || "",
                    pincode: data?.pincode || "",
                    state: data?.state || "",
                    websiteName: WebsiteName || "",
                    feedBack: reasonForReject || "",
                    agreementStartDate: !data?.agreementStartDate ? null : dayjs(data?.agreementStartDate)?.format('YYYY-MM-DD'),
                    agreementEndDate: !data?.agreementEndDate ? null : dayjs(data?.agreementEndDate)?.format('YYYY-MM-DD'),
                    clientRewardType: !data?.rewardType ? "FP" : data?.rewardType === 1 ? "FC" : "FP",
                    clientRewardPct: !data?.rewardsPercent ? 5 : +data?.rewardsPercent,
                    clientRewardAmount: !data?.rewardsRs ? null : +data?.rewardsRs,
                    submittedBy: data?.submittedBy,
                    contractRewardType: !data?.contractRewardType ? "FP" : data?.contractRewardType === 1 ? "FC" : "FP",
                    contractRewardPct: !data?.contractRewardPercent ? 2 : +data?.contractRewardPercent,
                    contractRewardAmount: !data?.contractRewardRs ? null : +data?.contractRewardRs,
                }
                setShowOverAllLoader(true)
                const response = await saveClient(payload).unwrap()
                setShowOverAllLoader(false)
                if (response.status === 200) {
                    Snackbar(response?.response?.Message, 'success')
                    navigate(isReferrals ? '/referrals' : '/client')
                } else if (response?.status === 'error') {
                    Snackbar(response?.data?.error_message, 'error')
                } else {
                    Snackbar("Not Authorized for Recruiter to Update", 'error')
                }
            }

            else {
                if (clientStatusId === 2 && !reasonForReject) {
                    setReasonError("Reason for Rejection is required.");
                    return; // Prevent further execution
                }
                const payload = {
                    alternateEmail: data?.alternateEmail || "",
                    alternateNumber: data?.alternateNumber || "",
                    city: data?.city || "",
                    clientAddress: data?.address || "",
                    clientEmail: email || "",
                    clientId: editScreen,
                    clientName: data?.clientName || "",
                    clientPhone: !data?.clientPhone ? "" : data?.clientPhone,
                    country: data?.country || "",
                    // createdBy: Profile?.profile?.emailId,
                    displayName: data?.displayName || "",
                    pincode: data?.pincode || "",
                    state: data?.state || "",
                    statusId: clientStatusId,
                    updatedBy: Profile?.profile?.emailId,
                    websiteName: WebsiteName || "",
                    feedBack: reasonForReject || "",
                    agreementStartDate: !data?.agreementStartDate ? null : dayjs(data?.agreementStartDate)?.format('YYYY-MM-DD'),
                    agreementEndDate: !data?.agreementEndDate ? null : dayjs(data?.agreementEndDate)?.format('YYYY-MM-DD'),
                    clientRewardType: !data?.rewardType ? "FP" : data?.rewardType === "1" ? "FC" : "FP",
                    clientRewardPct: +data?.rewardsPercent || 5,
                    clientRewardAmount: +data?.rewardsRs || null,
                    submittedBy: data?.submittedBy,
                    contractRewardType: !contractType ? "FP" : contractType === 1 ? "FC" : "FP",
                    contractRewardPct: !data?.contractRewardPercent ? 2 : +data?.contractRewardPercent,
                    contractRewardAmount: !data?.contractRewardRs ? null : +data?.contractRewardRs,
                }
                setShowOverAllLoader(true)
                const response = await saveClient(payload).unwrap()
                setShowOverAllLoader(false)
                if (response?.status === 'success' || response?.status === 200) {
                    Snackbar("Data Updated Sucessfully", 'success')
                    navigate(isReferrals ? '/referrals' : '/client')
                } else if (response?.status === "error") {
                    Snackbar(response?.data?.error_message, 'error')
                    // navigate(isReferrals ? '/referrals' : '/client')
                } else {
                    Snackbar("Not Authorized for Recruiter to Update", 'error')
                }
            }
        } catch (err) {
            Snackbar("Network Error", 'error')
        }
    }

    const onSubmitAddContact = async (data) => {
        try {
            const payload = {
                alternateEmail: data?.addClientAlternateEmail || "",
                alternateNumber: data?.addClientAlternateNo || "",
                clientId: editScreen,
                contactName: data?.contactName || "",
                contactNo: "",
                contactNumber: data?.contactNumber || "",
                designation: designation || "",
                email: data?.email || "",
                location: location || ""
            }

            const response = await saveClientContact(payload).unwrap()

            if (response?.response) {
                Snackbar(response?.response?.message, 'success')
            } else if (response?.data) {
                if (response?.status === "error") {
                    Snackbar(response?.data?.error_message, "error")
                }
            }
            getClientDatas()
            handleRemoveClientContact()
        } catch (err) {
            Snackbar("Network error", 'error')
        }
    }

    const handleRemoveClientContact = () => {
        resetAddContact()
        setDesignation("")
        setLocation("")
        setAddClientAlternateNo("")
        setAddClientAlternateEmail("")
    }

    const handleTableClientNameChange = (e, index) => {
        const value = e.target.value
        const updatedClientName = [...clientContactTableDatas]
        updatedClientName[index] = {
            ...updatedClientName[index],
            clientName: value
        }
        setClientContactTableDatas(updatedClientName);
    }

    const handleTableDesignation = (e, index) => {
        const value = e.target.value
        const updatedDesignation = [...clientContactTableDatas]
        updatedDesignation[index] = {
            ...updatedDesignation[index],
            designation: value
        }
        setClientContactTableDatas(updatedDesignation)
    }

    const handleTableLocation = (e, index) => {
        const value = e.target.value
        const updatedLocation = [...clientContactTableDatas]
        updatedLocation[index] = {
            ...updatedLocation[index],
            location: value
        }
        setClientContactTableDatas(updatedLocation)
    }

    const handleTableContactNo = (e, index) => {
        const value = e.target.value
        const updatedContactNo = [...clientContactTableDatas]
        updatedContactNo[index] = {
            ...updatedContactNo[index],
            contactNumber: value
        }
        setClientContactTableDatas(updatedContactNo)
    }

    const handleAlternateNumber = (e, index) => {
        const value = e.target.value
        const updatedAlternateNumber = [...clientContactTableDatas]
        updatedAlternateNumber[index] = {
            ...updatedAlternateNumber[index],
            alternateNumber: value
        }
        setClientContactTableDatas(updatedAlternateNumber)
    }

    const handleTableEmailChange = (e, index) => {
        const value = e.target.value
        const updatedEmail = [...clientContactTableDatas]
        updatedEmail[index] = {
            ...updatedEmail[index],
            email: value
        }
        setClientContactTableDatas(updatedEmail)
    }

    const handleTableAlternateEmail = (e, index) => {
        const value = e.target.value
        const updatedAlternateEmail = [...clientContactTableDatas]
        updatedAlternateEmail[index] = {
            ...updatedAlternateEmail[index],
            alternateEmail: value
        }
        setClientContactTableDatas(updatedAlternateEmail)
    }

    const handleSubmitUpdate = async (index) => {
        try {
            const item = clientContactTableDatas[index];
            const payload = {
                alternateEmail: item?.alternateEmail || "",
                alternateNumber: item?.alternateNumber || "",
                clientId: editScreen,
                contactName: item?.clientName || "",
                contactNo: item?.clientContact || 0,
                contactNumber: item?.contactNumber || "",
                designation: item?.designation || "",
                email: item?.email || "",
                location: item?.location || ""
            }

            const response = await saveClientContact(payload).unwrap()

            if (response?.response) {
                Snackbar(response?.response?.message, 'success')
            } else if (response?.data) {
                if (response?.status === "error") {
                    Snackbar(response?.data?.error_message, "error")
                }
            }
            setSubmitRows([])
            getClientDatas()
        } catch (err) {
            Snackbar("Network Error", 'error')
        }
    }

    const handleDeleteTableData = async () => {
        try {
            const item = clientContactTableDatas[clientContactRowIndex]
            const payload = {
                contactNo: item?.clientContact
            }

            const response = await deleteTableDatas(payload).unwrap()
            if (response?.status === 200) {
                Snackbar("Data Deleted Sucessfully", 'success')
            }
            handleClose()
            getClientDatas()
        } catch (err) {
            Snackbar("Network error", 'error')
        }
    }

    const tooltipMessage = Profile?.profile?.role === "coordinator" || Profile?.profile?.role === "recruiter"
        ? `Client has been approved you can't edit. For any changes please contact Open Recruiter team`
        : null;

    const handleNavigateBack = () => {
        // if(clientById){

        //     navigate('/client-view',{
        //         state:{
        //         clientId: clientId, clientName:clientTitle
        //         }
        //     })
        // }
        // else if (isReferrals === true) {
        //     navigate('/referrals')
        // } 
        // else {
        //     navigate('/client')
        // }
        navigate(-1)
    }

    const rewardTypes = [
        {
            id: 1,
            label: "Fixed Amount"
        },
        {
            id: 2,
            label: "Fixed Percentage"
        }
    ]

    const type = watch("rewardType")
    const contractType = watch("contractRewardType")

    const startDate = watch("agreementStartDate")
    const endDate = watch("agreementEndDate")

    useEffect(() => {
        if (dayjs(startDate).isAfter(dayjs(endDate))) {
            setValue("agreementEndDate", null)
        } else {
            return;
        }
    }, [startDate, endDate])

    useEffect(() => {
        if (type === 1) {
            setIsCost(true)
            reset(prev => ({ ...prev, rewardsPercent: "" }))

        } else {
            setIsCost(false)
            reset(prev => ({ ...prev, rewardsRs: "" }))

        }
    }, [type])

    useEffect(() => {
        if (contractType === 1) {
            setIsContractCost(true)
            reset(prev => ({ ...prev, contractRewardPercent: "" }))

        } else {
            setIsContractCost(false)
            reset(prev => ({ ...prev, contractRewardRs: "" }))

        }
    }, [contractType])

    useEffect(() => {
        setValue("submittedBy", useremail)

    }, [])

    const formattedOption = (getDropdownDatas?.response?.userList || []).map((item) => ({
        ...item,
        label: (
            <span>
                {item?.userFullName}{" "}
                <span style={{ fontSize: "12px", color: "#7F56D9" }}>
                    ({item?.roleName})
                </span>
            </span>
        ),
    }));


    return (
        <Box>
            {/* Box 1 - Client Details */}
            <Box className='container'>
                {showOverAllLoader ? (
                    <Loader />
                ) : ""}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={handleNavigateBack}>
                        <ArrowBackIcon sx={{ fontSize: '17px' }} />
                        <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
                    </Grid2>
                    <Typography className="title" sx={{ marginLeft: '10%' }}>Client Details</Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box className='formBox'>
                            <Grid2 item container rowGap={2} sx={{ display: !isSmallcreen ? 'flex' : "", justifyContent: 'space-between', flexDirection: isSmallcreen && 'column' }}>
                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel
                                        className="inputlabels"
                                        sx={{
                                            // width: '55%',
                                            // marginRight: '15%'
                                        }}>
                                        Client Name {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}
                                    </InputLabel>
                                    <Controller
                                        control={control}
                                        name={"clientName"}
                                        render={({ field }) => (
                                            <TextField
                                                {...register("clientName")}
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setClientNameLength(e.target.value.length);
                                                }}
                                                inputProps={{ maxLength }}
                                                size="small"
                                                // className="txtfield"
                                                className="textfields"
                                                placeholder="Enter Client Name"
                                                sx={{
                                                    flexGrow: 1,
                                                    "& .MuiFormHelperText-root": {
                                                        color: errors.clientName ? "red" : "inherit",
                                                        marginLeft: '-1px'
                                                    },
                                                }}
                                                fullWidth
                                                helperText={errors?.clientName ? errors?.clientName?.message : ""}
                                            />
                                        )}
                                    />
                                    <p style={{ fontSize: '12px', color: clientNameLength >= maxLength ? 'red' : '#666' }}>
                                        You have {maxLength - clientNameLength} characters remaining
                                    </p>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Display Name {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"displayName"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...register("displayName")}
                                                    {...field}
                                                    onChange={(e) => {
                                                        field.onChange(e);
                                                        setDisplayNameLength(e.target.value.length);
                                                    }}
                                                    inputProps={{ maxLength }}
                                                    size="small"
                                                    className="textfields"
                                                    placeholder="Enter Display Name"
                                                    sx={{
                                                        flexGrow: 1,
                                                        "& .MuiFormHelperText-root": {
                                                            color: errors?.displayName ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.displayName ? errors?.displayName?.message : ""}
                                                />
                                            )}
                                        />
                                    </div>
                                    <p style={{ fontSize: '12px', color: displayNameLength >= maxLength ? 'red' : '#666' }}>
                                        You have {maxLength - displayNameLength} characters remaining
                                    </p>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Contact Number {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"clientPhone"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...register("clientPhone")}
                                                    {...field}
                                                    type="text"
                                                    size="small"
                                                    className="textfields"
                                                    placeholder="Enter Contact number"
                                                    onChangeCapture={(e) => {
                                                        field.onChange(e);
                                                        trigger('alternateNumber')
                                                    }}
                                                    sx={{
                                                        flexGrow: 1, "& .MuiFormHelperText-root": {
                                                            color: errors.clientPhone ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                            display: "none",
                                                        },
                                                        "& input[type=number]": {
                                                            MozAppearance: "textfield",
                                                        },

                                                    }}
                                                    helperText={errors?.clientPhone ? errors?.clientPhone?.message : ""}
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Email {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"clientEmail"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                size="small"
                                                className="textfields"
                                                placeholder="Enter Email"
                                                sx={{
                                                    flexGrow: 1,
                                                    "& .MuiFormHelperText-root": {
                                                        color: 'red',
                                                        marginLeft: '-1px'
                                                    }
                                                }}
                                                value={email}
                                                onChange={(e) => {
                                                    handleEmailChange(e)
                                                    field.onChange(e)
                                                    trigger('alternateEmail')
                                                }}
                                                helperText={errors?.clientEmail ? errors?.clientEmail?.message : ""}
                                            />
                                        )}
                                    />
                                </Grid2>
                            </Grid2>

                            <Grid2 item sx={{ alignItems: "center", width: '100%', marginTop: '15px' }}>
                                <InputLabel className="inputlabels">Street/Building {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                <Controller
                                    control={control}
                                    name={"address"}
                                    render={({ field }) => (
                                        <textarea
                                            {...field}
                                            className="clientTextArea"
                                            size="small"
                                            placeholder="Enter Street/Building"
                                            style={{ resize: 'none', height: '70px', borderRadius: '10px' }}
                                        />
                                    )}
                                />
                                <span style={{ color: 'red', fontSize: '0.8rem' }}>{errors?.address ? errors?.address?.message : ""}</span>
                            </Grid2>

                            {/* container 1 */}
                            <Grid2 item container rowGap={2} sx={{ display: !isSmallcreen ? 'flex' : "", justifyContent: 'space-between', flexDirection: isSmallcreen && 'column', marginTop: '15px' }}>
                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> State {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"state"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                size="small"
                                                className="textfields"
                                                placeholder="Enter State"
                                                sx={{ flexGrow: 1 }}
                                            />
                                        )}
                                    />
                                    <span style={{ color: 'red', fontSize: '0.75rem' }}>{errors?.state ? errors?.state?.message : ""}</span>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Country {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"country"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                size="small"
                                                className="textfields"
                                                placeholder="Enter Country"
                                                sx={{ flexGrow: 1 }}
                                            />
                                        )}
                                    />
                                    <span style={{ color: 'red', fontSize: '0.75rem' }}>{errors?.country ? errors?.country?.message : ""}</span>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> City<span style={{ color: 'red' }}> *</span></InputLabel>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={'city'}
                                            render={({ field }) => (
                                                <TextField
                                                    {...register('city')}
                                                    {...field}
                                                    size="small"
                                                    className="textfields"
                                                    placeholder="Enter City"
                                                    sx={{
                                                        flexGrow: 1, "& .MuiFormHelperText-root": {
                                                            color: errors.city ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                    }}
                                                    helperText={errors?.city ? errors?.city?.message : ""}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Pincode</InputLabel>
                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                        <Controller
                                            control={control}
                                            name={"pincode"}
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    {...register('pincode')}
                                                    size="small"
                                                    className="textfields"
                                                    placeholder="Enter Pincode"
                                                    sx={{
                                                        flexGrow: 1, "& .MuiFormHelperText-root": {
                                                            color: errors.pincode ? "red" : "inherit",
                                                            marginLeft: '-1px'
                                                        },
                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                            display: "none",
                                                        },
                                                    }}
                                                    helperText={errors?.pincode ? errors?.pincode?.message : ""}
                                                    type="number"
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                            )}
                                        />
                                    </div>
                                </Grid2>

                                <Grid2 item sx={{ dalignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Agreement Start Date {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"agreementStartDate"}
                                        render={({ field }) => (
                                            <MuiDatePicker
                                                {...field}
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(date) => field.onChange(date)}
                                                className="textfields"
                                                // disabled={editScreen? null : end }
                                                onWheel={(e) => e.target.blur()}
                                                slotProps={{
                                                    textField: {
                                                        placeholder: 'Select Agreement Start Date',
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                    {
                                        <span style={{ color: 'red', fontSize: '0.75rem' }}>{errors?.agreementStartDate ? errors?.agreementStartDate?.message : ""}</span>
                                    }
                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Agreement End Date {userRole !== 'recruiter' || isExternal === "N" ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"agreementEndDate"}
                                        render={({ field }) => (
                                            <MuiDatePicker
                                                {...field}
                                                value={field.value ? dayjs(field.value) : null}
                                                onChange={(date) => field.onChange(date)}
                                                className="textfields"
                                                placeholder="Select Agreement End Date"
                                                minDate={dayjs(startDate).add(1, 'day')}
                                                onWheel={(e) => e.target.blur()}
                                                slotProps={{
                                                    textField: {
                                                        placeholder: 'Select Agreement End Date'
                                                    }
                                                }}
                                                disabled={!startDate}
                                                required={startDate}
                                            />
                                        )}
                                    />
                                    {
                                        userRole !== "recruiter" ? (
                                            <span style={{ color: 'red', fontSize: '0.75rem' }}>
                                                {errors?.agreementEndDate?.message || ""}
                                            </span>
                                        ) : (
                                            startDate && !endDate ? (
                                                <span style={{ color: 'red', fontSize: '0.75rem' }}>
                                                    Agreement End date is required
                                                </span>
                                            ) : null
                                        )
                                    }


                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Alternate Email</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"alternateEmail"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                {...register('alternateEmail')}
                                                size="small"
                                                className="textfields"
                                                placeholder="Enter Alternate Email"
                                                sx={{ flexGrow: 1 }}
                                            // value={alternateEmail}
                                            // onChange={handleAlternateEmailChange}
                                            />
                                        )}
                                    />
                                    {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.alternateEmail ? errors.alternateEmail?.message : ""}</span>}

                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Alternate Number</InputLabel>
                                    <Controller
                                        control={control}
                                        name={"alternateNumber"}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                {...register('alternateNumber')}
                                                size="small"
                                                className="textfields"
                                                placeholder="Enter Alternate Number"
                                                sx={{
                                                    flexGrow: 1, "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                        display: "none",
                                                    },
                                                }}
                                                // value={alternateNumber}
                                                // onChange={handleAlternateNoChange}
                                                type="number"
                                                onWheel={(e) => e.target.blur()}
                                            />
                                        )}
                                    />
                                    {<span style={{ color: 'red', fontSize: '12px' }}>{errors?.alternateNumber ? errors.alternateNumber?.message : ""}</span>}

                                </Grid2>

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    <InputLabel className="inputlabels"> Website Name</InputLabel>
                                    <TextField
                                        size="small"
                                        className="textfields"
                                        placeholder="Enter Website"
                                        sx={{ flexGrow: 1 }}
                                        value={WebsiteName}
                                        onChange={handleWebsiteNameChange}
                                    />
                                </Grid2>

                                {
                                    userRole === "admin" && (
                                        <Box sx={{ width: !isSmallcreen ? "40%" : "100%" }}>
                                            <InputLabel className="inputlabels">
                                                Sourced By <span style={{ color: "red" }}>*</span>
                                            </InputLabel>
                                            <Controller
                                                name="submittedBy"
                                                control={control}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        {...field}
                                                        IconComponent={KeyboardArrowDownIcon}
                                                        className="dropdown"
                                                        placeholder="Select email"
                                                        disabled={userRole !== 'admin'}
                                                        displayEmpty
                                                        helperText={
                                                            errors?.submittedBy
                                                                ? errors?.submittedBy?.message
                                                                : ""
                                                        }
                                                        options={
                                                            formattedOption || []
                                                        }
                                                        valueKey="userEmail"
                                                        labelKey="label"
                                                        sx={{
                                                            height: "35px",
                                                            width: "100%",
                                                            fontSize: "14px",
                                                            "& .MuiInputBase-root": {
                                                                fontSize: "14px", // Apply font size to input
                                                            },
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors?.submittedBy && (
                                                <div style={{ color: "red", fontSize: "12px" }}>
                                                    {" "}
                                                    Email is required
                                                </div>
                                            )}
                                        </Box>
                                    )
                                }



                                {
                                    editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                            <InputLabel className="addJobPostingInput"> Client Commission Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name={"rewardType"}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        {...field}
                                                        className="dropdown"
                                                        displayEmpty
                                                        placeholder="Select Reward Type"
                                                        valueKey="id"
                                                        labelKey="label"
                                                        options={rewardTypes || []}
                                                    />
                                                )}
                                            />
                                            {errors?.rewardType?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.rewardType?.message}
                                                </div>
                                            )}

                                        </Grid2>
                                    ) : ('')
                                }

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    {isCost === true && editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <>
                                            <InputLabel className="addJobPostingInput">Commission(Rs) <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="rewardsRs"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        className="textfields"
                                                        size="small"
                                                        type="number"
                                                        sx={{
                                                            flex: 1,
                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                cursor: "not-allowed"
                                                            },
                                                        }}
                                                        placeholder="Enter Rewards(Rs)"
                                                        onWheel={(e) => e.target.blur()}
                                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                                        disabled={!type}
                                                    />
                                                )}
                                            />
                                            {errors?.rewardsRs?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.rewardsRs?.message}
                                                </div>
                                            )}
                                        </>
                                    ) : ("")}

                                    {isCost === false && editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <>
                                            <InputLabel className="addJobPostingInput">Commission(%) <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="rewardsPercent"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        className="textfields"
                                                        size="small"
                                                        type="number"
                                                        sx={{
                                                            flex: 1,
                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                cursor: "not-allowed"
                                                            },
                                                        }}
                                                        placeholder="Enter Rewards(%)"
                                                        onWheel={(e) => e.target.blur()}
                                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                                        disabled={!type}
                                                    />
                                                )}
                                            />
                                            {errors?.rewardsPercent?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.rewardsPercent?.message}
                                                </div>
                                            )}
                                        </>
                                    ) : ('')}

                                </Grid2>

                                {
                                    editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                            <InputLabel className="addJobPostingInput"> Client Contract Commission Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name={"contractRewardType"}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        {...field}
                                                        className="dropdown"
                                                        displayEmpty
                                                        placeholder="Select Reward Type"
                                                        valueKey="id"
                                                        labelKey="label"
                                                        options={rewardTypes || []}
                                                    />
                                                )}
                                            />
                                            {errors?.contractRewardType?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.contractRewardType?.message}
                                                </div>
                                            )}

                                        </Grid2>
                                    ) : ('')
                                }

                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                    {isContractCost === true && editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <>
                                            <InputLabel className="addJobPostingInput">Contract Commission(Rs) <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="contractRewardRs"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        className="textfields"
                                                        size="small"
                                                        type="number"
                                                        sx={{
                                                            flex: 1,
                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                cursor: "not-allowed"
                                                            },
                                                        }}
                                                        placeholder="Enter Rewards(Rs)"
                                                        onWheel={(e) => e.target.blur()}
                                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                                        disabled={!type}
                                                    />
                                                )}
                                            />
                                            {errors?.contractRewardRs?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.contractRewardRs?.message}
                                                </div>
                                            )}
                                        </>
                                    ) : ("")}

                                    {isContractCost === false && editScreen && isReferralClient === "Y" && userRole === "admin" ? (
                                        <>
                                            <InputLabel className="addJobPostingInput"> Contract Commission(%) <span style={{ color: 'red' }}>*</span></InputLabel>
                                            <Controller
                                                control={control}
                                                name="contractRewardPercent"
                                                render={({ field }) => (
                                                    <TextField
                                                        {...field}
                                                        className="textfields"
                                                        size="small"
                                                        type="number"
                                                        sx={{
                                                            flex: 1,
                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                cursor: "not-allowed"
                                                            },
                                                        }}
                                                        placeholder="Enter Rewards(%)"
                                                        onWheel={(e) => e.target.blur()}
                                                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                                                        disabled={!type}
                                                    />
                                                )}
                                            />
                                            {errors?.contractRewardPercent?.message && (
                                                <div style={{ color: 'red', fontSize: '0.7rem' }}>
                                                    {errors?.contractRewardPercent?.message}
                                                </div>
                                            )}
                                        </>
                                    ) : ('')}

                                </Grid2>

                                {params?.id && userRole === "admin" && (
                                    <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                        <InputLabel className="inputlabels"> Status {editScreen ? <span style={{ color: 'red' }}> *</span> : ""}</InputLabel>
                                        <Select
                                            IconComponent={KeyboardArrowDownIcon}
                                            displayEmpty
                                            value={clientStatusId}
                                            onChange={handleStatusChange}
                                            open={openStatus}
                                            onOpen={() => setOpenStatus(true)}
                                            onClose={() => setOpenStatus(false)}
                                            size="small"
                                            sx={{ height: '35px', width: '100%', fontSize: '14px', borderRadius: '10px' }}
                                        >
                                            <MenuItem value="" disabled>Select Status</MenuItem>
                                            <MenuItem value={1} className="menuitems">Approve</MenuItem>
                                            <MenuItem value={2} className="menuitems">Reject</MenuItem>
                                            <MenuItem value={3} className="menuitems">Pending</MenuItem>
                                        </Select>
                                    </Grid2>
                                )}

                                {clientStatusId === 2 ? (
                                    <Grid2 item sx={{ alignItems: "center", width: '100%', marginTop: '10px' }}>
                                        <InputLabel className="inputlabels">Reason For Rejection<span style={{ color: 'red' }}> *</span></InputLabel>
                                        <textarea
                                            className="clientTextArea"
                                            size="small"
                                            placeholder="Enter Reason For Reject"
                                            value={reasonForReject}
                                            onChange={hanldeReasonForReject}
                                            style={{ resize: 'none', height: '70px', borderRadius: '10px' }}
                                        />
                                        {reasonError && (
                                            <p style={{ color: 'red', fontSize: '12px' }}>Reason For Rejection is Required</p>
                                        )}

                                    </Grid2>
                                ) : ("")}



                            </Grid2>


                        </Box>
                    </Box>
                    <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: "20px", marginTop: "30px" }}>
                        <MUICancelButton title="Cancel" component={Link} to={isReferrals ? '/referrals' : '/client'} />
                        {editScreen ? (
                            <Tooltip title={clientStatusId === 1 ? tooltipMessage : ""}
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            backgroundColor: "#0A0D12",
                                            borderRadius: '8px',
                                            padding: '8px 12px',
                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                        }
                                    }
                                }} arrow>
                                <span>
                                    <MUIButton title='Save Changes' type="submit" sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }}
                                        disabled={userRole !== "admin" && clientStatusId === 1} />
                                </span>
                            </Tooltip>
                        ) : (
                            <MUIButton title='Save Changes' type="submit" sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }} />
                        )}

                    </Grid2>
                </form>
            </Box>

            {/* Second Box - Add Client Contacts */}
            {
                params?.id && (
                    <>
                        <Box sx={{ padding: '32px', backgroundColor: '#fff' }}>
                            <Typography className="title" sx={{ marginLeft: '10%' }}>Add Client Contacts</Typography>
                            <form onSubmit={handleSubmitAddContact(onSubmitAddContact)}>
                                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Box className='formBox'>
                                        <Grid2 container sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                            {/* container 1 */}
                                            <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: isSmallcreen && 'column', justifyContent: 'space-between', width: '100%' }}>
                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Name <span style={{ color: 'red' }}>*</span> </InputLabel>
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                        <Controller
                                                            control={controlAddContact}
                                                            name={"contactName"}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    className="textfields"
                                                                    placeholder="Enter name"
                                                                    sx={{
                                                                        flexGrow: 1, "& .MuiFormHelperText-root": {
                                                                            color: errorsAddContact?.contactName ? "red" : "inherit",
                                                                            marginLeft: '-1px'
                                                                        },
                                                                    }}
                                                                    helperText={errorsAddContact?.contactName ? errorsAddContact?.contactName?.message : ""}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </Grid2>

                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Designation</InputLabel>
                                                    <TextField
                                                        className="textfields"
                                                        placeholder="Enter designation"
                                                        value={designation}
                                                        onChange={handleDesignationChange}
                                                    />
                                                </Grid2>

                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Contact Number <span style={{ color: 'red' }}>*</span> </InputLabel>
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                                        <Controller
                                                            control={controlAddContact}
                                                            name={"contactNumber"}
                                                            render={({ field }) => (
                                                                <TextField
                                                                    {...field}
                                                                    className="textfields"
                                                                    placeholder="Enter contact number"
                                                                    sx={{
                                                                        flexGrow: 1, "& .MuiFormHelperText-root": {
                                                                            color: errorsAddContact?.contactNumber ? "red" : "inherit",
                                                                            marginLeft: '-1px'
                                                                        },
                                                                        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                                            display: "none",
                                                                        },
                                                                    }}
                                                                    helperText={errorsAddContact?.contactNumber ? errorsAddContact?.contactNumber?.message : ""}
                                                                    type="text"
                                                                    onWheel={(e) => e.target.blur()}
                                                                />
                                                            )}
                                                        />
                                                    </div>
                                                </Grid2>

                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Email <span style={{ color: 'red' }}>*</span> </InputLabel>
                                                    <Controller
                                                        control={controlAddContact}
                                                        name={"email"}
                                                        render={({ field }) => (
                                                            <TextField
                                                                {...field}
                                                                className="textfields"
                                                                placeholder="Enter email"
                                                                sx={{
                                                                    flexGrow: 1, "& .MuiFormHelperText-root": {
                                                                        color: errorsAddContact?.email ? "red" : "inherit",
                                                                        marginLeft: '-1px'
                                                                    },
                                                                }}
                                                                helperText={errorsAddContact?.email ? errorsAddContact?.email?.message : ""}
                                                            />
                                                        )}
                                                    />

                                                </Grid2>
                                            </Grid2>

                                            {/* Container 2 */}
                                            <Grid2 item container rowGap={2} sx={{ display: 'flex', flexDirection: isSmallcreen && 'column', justifyContent: 'space-between', marginTop: '15px', width: '100%' }}>
                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Location</InputLabel>
                                                    <TextField
                                                        className="textfields"
                                                        placeholder="Enter location"
                                                        value={location}
                                                        onChange={handleLocationChange}
                                                    />
                                                </Grid2>

                                                <Grid2 item sx={{ dalignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Alternate Number</InputLabel>
                                                    <TextField
                                                        className="textfields"
                                                        placeholder="Enter alternate number"
                                                        value={addClientAlternateNo}
                                                        onChange={handleAddClientAlternateNoChange}
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                </Grid2>

                                                <Grid2 item sx={{ alignItems: "center", width: !isSmallcreen ? '40%' : '100%' }}>
                                                    <InputLabel className="inputlabels"> Alternate Email</InputLabel>
                                                    <TextField
                                                        className="textfields"
                                                        placeholder="Enter alternate email"
                                                        value={addClientAlternateEmail}
                                                        onChange={handleAddClientAlternateEmailChange}
                                                    />
                                                </Grid2>
                                            </Grid2>
                                        </Grid2>
                                    </Box>
                                </Box>
                                <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: "20px", marginTop: "30px" }}>
                                    <MUICancelButton title="Cancel" component={Link} to={isReferrals ? '/referrals' : '/client'} />
                                    <MUIButton title='Save Changes' type="submit" sx={{ backgroundColor: '#7F56D9', borderRadius: '7px', width: '130px' }} />
                                </Grid2>
                            </form>
                        </Box>

                        <Box className='container'>
                            <Typography className="title">Update Client Contacts</Typography>
                            <Grid2 item container>
                                <Paper sx={{ width: '100%', overflow: 'auto', border: '1px solid #E9EAEB' }} elevation={0}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="tableHeadersCell" sx={{ width: "16%" }}>Name</TableCell>
                                                <TableCell className="tableHeadersCell">Designation</TableCell>
                                                <TableCell className="tableHeadersCell">Location</TableCell>
                                                <TableCell className="tableHeadersCell" sx={{ width: "18%" }}>Contact / Alternate No</TableCell>
                                                <TableCell className="tableHeadersCell" sx={{ width: "18%" }}>Email / Alternate Email</TableCell>
                                                <TableCell className="tableHeadersCell" align='center'>Update</TableCell>
                                                <TableCell className="tableHeadersCell">Action</TableCell>
                                            </TableRow>
                                        </TableHead>

                                        {clientContactTableDatas?.length > 0 ? (
                                            <TableBody>
                                                {clientContactTableDatas?.map((item, index) =>
                                                    <TableRow>
                                                        <TableCell className="tableBodyCell">
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                value={item?.clientName || ""}
                                                                sx={{ marginBottom: "45px" }}
                                                                onChange={(e) => handleTableClientNameChange(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Name"
                                                            />
                                                        </TableCell>

                                                        <TableCell className="tableBodyCell">
                                                            <TextField
                                                                size="small"
                                                                sx={{ marginBottom: "45px" }}
                                                                className="tabletextfields"
                                                                value={item?.designation || ""}
                                                                onChange={(e) => handleTableDesignation(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Designation"
                                                            />
                                                        </TableCell>

                                                        <TableCell className="tableBodyCell">
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                sx={{ marginBottom: "45px" }}
                                                                value={item?.location || ""}
                                                                onChange={(e) => handleTableLocation(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Location"
                                                            />
                                                        </TableCell>

                                                        {/* <TableCell sx={{ paddingTop: '40px' }}> */}
                                                        <TableCell className="tableBodyCell">
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                value={item?.contactNumber}
                                                                onChange={(e) => handleTableContactNo(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Contact Number"
                                                            />
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                sx={{ marginTop: "15px" }}
                                                                value={item.alternateNumber}
                                                                onChange={(e) => handleAlternateNumber(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Alternate Number"
                                                            />
                                                        </TableCell>

                                                        <TableCell className="tableBodyCell">
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                value={item?.email}
                                                                onChange={(e) => handleTableEmailChange(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder="Enter Email"
                                                            />
                                                            <TextField
                                                                size="small"
                                                                className="tabletextfields"
                                                                sx={{ marginTop: "15px" }}
                                                                value={item?.alternateEmail}
                                                                onChange={(e) => handleTableAlternateEmail(e, index)}
                                                                disabled={!submitRows?.includes(index)}
                                                                placeholder='Enter Alternate Email'
                                                            />
                                                        </TableCell>

                                                        <TableCell className="tableBodyCell">
                                                            <div style={{ marginBottom: "45px" }}>
                                                                {submitRows?.includes(index) ? (
                                                                    <MUIButton
                                                                        title="Submit"
                                                                        onClick={() => handleSubmitUpdate(index)}
                                                                        sx={{
                                                                            minWidth: "80px",
                                                                            height: "30px",
                                                                            fontSize: "11px",
                                                                            backgroundColor: "#7F56D9",
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <MUICancelButton
                                                                        title="Update"
                                                                        onClick={() => handleToggleUpdate(index)}
                                                                        sx={{
                                                                            minWidth: "80px",
                                                                            height: "30px",
                                                                            fontSize: "11px",
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>
                                                        </TableCell>


                                                        <TableCell className="tableBodyCell" align='center'>
                                                            <Tooltip
                                                                slotProps={{
                                                                    tooltip: {
                                                                        sx: {
                                                                            backgroundColor: "#0A0D12",
                                                                            borderRadius: '8px',
                                                                            padding: '8px 12px',
                                                                            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                        }
                                                                    }
                                                                }}
                                                                title={userRole !== "recruiter" ? "Delete" : "You can't delete the client details"}>
                                                                <DeleteIcon onClick={userRole !== "recruiter" ? () => handleOpen(item, index) : null} stroke={'red'}
                                                                    style={{ marginBottom: '40px' }}
                                                                    cursor={userRole !== "recruiter" ? "pointer" : "not-allowed"} />
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        ) : (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell colSpan={8}>
                                                        <Typography className="emptydatas">No Data Found</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        )}
                                    </Table>
                                </Paper>
                                <Grid2 item>
                                    <Dialog
                                        open={open}
                                        scroll='paper'
                                        maxWidth="xs"
                                        sx={{
                                            "& .MuiDialog-paper": {
                                                width: '90%',
                                                maxWidth: '500px',
                                                height: 'auto',
                                                borderRadius: '15px',
                                                padding: '3px'
                                            },
                                        }}
                                    >
                                        <DialogContent>
                                            <DialogContentText>
                                                <div style={{ display: 'flex', gap: '12px', marginTop: '7px' }}>
                                                    <div style={{ backgroundColor: '#FEE4E2', borderRadius: '40px', height: '40px', width: '45px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                        <DeleteIcon stroke={'red'} />
                                                    </div>

                                                    <div>
                                                        <Typography sx={{ color: '#181D27', fontWeight: 600, fontSize: '17px' }}>Delete Client Contact?</Typography>
                                                        <Typography sx={{ color: '#535862', fontWeight: 400, fontSize: '14px' }}>
                                                            Are you sure you want to delete this post? This action cannot be undone.
                                                        </Typography>
                                                    </div>
                                                </div>

                                                <Grid2 item sx={{ marginTop: '25px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                                    <MUICancelButton title='Cancel' onClick={handleClose} />
                                                    <MUIButton title='Delete' onClick={handleDeleteTableData} sx={{ backgroundColor: '#D92D20', borderRadius: '10px' }} />
                                                </Grid2>
                                            </DialogContentText>
                                        </DialogContent>
                                    </Dialog>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </>
                )
            }
        </Box >
    )
}

export default AddClient